"use strict"; // no itx

export default class XmlNode {
  constructor(tagname) {
    this["#name"] = tagname;
    this.a = {};
    this.items = []; //nested tags, text, cdata, comments in order
  }

  get tagname() {
    return this["#name"];
  }
  set tagname(newValue) {
    this["#name"] = newValue;
  }

  add(key, val) {
    if (key == "#text") {
      key = "_";
    }
    this[key] = val;
  }

  addChild(node) {
    this[node.tagname] = node;
    this.items.push(node);
  }
}
